import { inject } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { firstValueFrom } from "rxjs";
import { AuthService } from "../services/auth/auth.service";

export const authenticatedGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (route.fragment?.startsWith('access_token=')) {
    return true;
  }

  const isAuthenticated = await firstValueFrom(auth.authenticated$);

  if (isAuthenticated) {
    return true;
  } else {
    const navExtras = route.fragment
      ? {
        // in case of OAuth provider signin we need to also preserve the fragments
        // as they may contain access tokens
        fragment: route.fragment,
      }
      : {
        // capture the current url so we can redirect after signin
        queryParams: { redirect_url: state.url },
      };
    router.navigate(["signin"], navExtras);
    return false;
  }
};
